import styled, { css } from 'styled-components';
import { mediaMixin, spaceMixin } from '@zillow/constellation';

export const StyledRow = styled.div<{ showHeader: boolean }>`
  margin-top: ${spaceMixin('xs')};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;

  ${(props) =>
    props.showHeader &&
    css`
      padding-bottom: ${spaceMixin('lg')};
      padding-top: ${spaceMixin('sm')};
      margin: -${spaceMixin('xs')};
    `}

  ${mediaMixin(
    'lg',
    css`
      justify-content: flex-start;
    `,
  )};
`;

export const StyledCol = styled.div`
  width: 100%;
  margin-bottom: ${spaceMixin('sm')};

  ${mediaMixin(
    'sm',
    css`
      width: 320px;
    `,
  )};
`;
